@let carrierOfGeneticDiseases =
  form.get('shared.patientHistory.carrierOfGeneticDiseases.hasHistory')?.value;

@let showFraternityQuestions =
  fieldSet.includes(ServiceDataFields.FraternityInformation) &&
  parentingTestType() === ParentingTestType.Fraternity;

@if (
  fieldSet.includes(ServiceDataFields.PatientHistoryInformation) ||
  showFraternityQuestions
) {
  <section
    *appRequirePermission="id ? ['medicalInformation'] : []"
    [attr.data-cy]="ServiceDataFields.PatientHistoryInformation + '-section'"
  >
    <p class="caption mb-1">
      {{ 'serviceData.form.patientHistory' | translate }}
    </p>
    <hr class="mt-0" />
    <ng-container formGroupName="rhd">
      <ng-container formGroupName="patientHistory">
        @if (fieldSet.includes(ServiceDataFields.RhdStatus)) {
          <ng-container formGroupName="rhdStatus">
            <app-service-data-form-carrier-condition
              validationTranslation="serviceData.form.validation.rhdStatus"
              [title]="'serviceData.form.patientRhdNegative' | translate"
              [property]="'status'"
              [fieldSet]="fieldSet"
              [field]="ServiceDataFields.RhdStatus"
            />
          </ng-container>
        }
      </ng-container>
    </ng-container>
    <ng-container formGroupName="carrier">
      <ng-container formGroupName="patientHistory">
        <ng-container formGroupName="cysticFibrosisHistory">
          <app-service-data-form-disease-history
            translationGroup="cysticFibrosisHistory"
            [relationToPatient]="true"
            [fieldSet]="fieldSet"
            [field]="ServiceDataFields.FamilyHistoryOfCysticFibrosis"
          />
        </ng-container>
      </ng-container>
    </ng-container>
    <ng-container formGroupName="cancerScreen">
      <ng-container formGroupName="patientHistory">
        <ng-container formGroupName="diseaseHistory">
          <app-service-data-form-disease-history
            translationGroup="diseaseHistory"
            [ageOfOnset]="true"
            [fieldSet]="fieldSet"
            [field]="ServiceDataFields.DiseaseHistory"
          />
        </ng-container>
        <ng-container formGroupName="familyCancerHistory">
          <app-service-data-form-disease-history
            translationGroup="familyCancerHistory"
            [relationToPatient]="true"
            [ageOfOnset]="true"
            [fieldSet]="fieldSet"
            [field]="ServiceDataFields.FamilyCancerHistory"
          />
        </ng-container>
        <ng-container formGroupName="knownFamilyMutations">
          <app-service-data-form-disease-history
            translationGroup="knownFamilyMutations"
            [relationToPatient]="true"
            [ageOfOnset]="true"
            [fieldSet]="fieldSet"
            [field]="ServiceDataFields.KnownFamilyMutations"
          />
        </ng-container>
      </ng-container>
    </ng-container>
    <ng-container formGroupName="galleri">
      <ng-container formGroupName="patientHistory">
        @if (
          fieldSet.includes(ServiceDataFields.CurrentlyDiagnosedWithCancer)
        ) {
          <app-service-data-form-carrier-condition
            [title]="
              'serviceData.form.galleri.isCurrentlyDiagnosedWithCancer'
                | translate
            "
            [property]="'currentlyDiagnosedWithCancer'"
            validationTranslation="serviceData.form.validation.galleri"
            [fieldSet]="fieldSet"
            [field]="ServiceDataFields.CurrentlyDiagnosedWithCancer"
          />
        }
        @if (fieldSet.includes(ServiceDataFields.CancerSurvivor)) {
          <ng-container formGroupName="cancerSurvivor">
            <app-service-data-form-condition-history
              [config]="{
                type: RadioFormType.Double,
                answerProperty: 'isSurvivor',
                subAnswerProperty: 'moreThanThreeYearsAgo',
                subAnswerValues: { yes: true, no: false },
                title: {
                  question:
                    'serviceData.form.galleri.isCancerSurvivor' | translate,
                  subQuestion:
                    'serviceData.form.galleri.moreThanThreeYearsAgo'
                    | translate,
                },
                validationTranslation: {
                  subAnswer: 'serviceData.form.validation.galleri',
                },
              }"
              [fieldSet]="fieldSet"
              [field]="ServiceDataFields.CancerSurvivor"
            />
          </ng-container>
        }
      </ng-container>
    </ng-container>
    <!-- Shared by Galleri and NEG Single Carrier -->
    @if (fieldSet.includes(ServiceDataFields.BoneMarrowTransplant)) {
      <ng-container formGroupName="shared">
        <ng-container formGroupName="patientHistory">
          <ng-container formGroupName="boneMarrowTransplant">
            <app-service-data-form-condition-history
              [config]="{
                type: RadioFormType.Single,
                title: {
                  question:
                    'serviceData.form.hasBoneMarrowTransplant' | translate,
                },
              }"
              [fieldSet]="fieldSet"
              [field]="ServiceDataFields.BoneMarrowTransplant"
            />
          </ng-container>
        </ng-container>
      </ng-container>
    }
    <ng-container formGroupName="galleri">
      <ng-container formGroupName="patientHistory">
        @if (fieldSet.includes(ServiceDataFields.SolidOrganTransplant)) {
          <ng-container formGroupName="solidOrganTransplant">
            <app-service-data-form-condition-history
              [config]="{
                type: RadioFormType.Single,
                title: {
                  question:
                    'serviceData.form.galleri.hasSolidOrganTransplant'
                    | translate,
                },
              }"
              [fieldSet]="fieldSet"
              [field]="ServiceDataFields.SolidOrganTransplant"
            />
          </ng-container>
        }
        @if (fieldSet.includes(ServiceDataFields.CancerSuspicion)) {
          <ng-container formGroupName="cancerSuspicion">
            <app-service-data-form-carrier-condition
              [title]="
                'serviceData.form.galleri.hasCancerSuspicion' | translate
              "
              [property]="'isSuspicious'"
              [descriptionProperty]="'suspicionDescription'"
              [descriptionTitle]="
                'serviceData.form.galleri.suspicionDescription' | translate
              "
              [descriptionPlaceholder]="
                'serviceData.form.galleri.suspicionDescriptionPlaceholder'
                  | translate
              "
              [fieldSet]="fieldSet"
              [field]="ServiceDataFields.CancerSuspicion"
            />
          </ng-container>
        }
      </ng-container>
    </ng-container>
    <ng-container formGroupName="venisafe">
      <ng-container formGroupName="patientHistory">
        <ng-container formGroupName="cardiovascularConditions">
          <app-service-data-form-disease-history
            translationGroup="cardiovascularConditions"
            [fieldSet]="fieldSet"
            [field]="ServiceDataFields.CardiovascularConditions"
          />
        </ng-container>
        <ng-container formGroupName="cardiovascularConditionsInFamily">
          <app-service-data-form-disease-history
            translationGroup="cardiovascularConditionsInFamily"
            [relationToPatient]="true"
            [fieldSet]="fieldSet"
            [field]="ServiceDataFields.CardiovascularConditionsInFamilyHistory"
          />
        </ng-container>
      </ng-container>
    </ng-container>
    <ng-container formGroupName="shared">
      <ng-container formGroupName="patientHistory">
        <app-service-data-form-birth-information [fieldSet]="fieldSet" />
        <ng-container formGroupName="pregnancyDiseaseHistory">
          <app-service-data-form-disease-history
            translationGroup="pregnancyDisease"
            [fieldSet]="fieldSet"
            [field]="ServiceDataFields.PreviousPregnanciesGeneticCondition"
          />
        </ng-container>

        <ng-container formGroupName="familyDiseaseHistory">
          <app-service-data-form-disease-history
            translationGroup="familyDisease"
            [relationToPatient]="true"
            [fieldSet]="fieldSet"
            [field]="ServiceDataFields.FamilyHistoryOfGeneticDiseases"
          />
        </ng-container>
        @if (
          carrierOfGeneticDiseases !== null &&
          carrierOfGeneticDiseases !== undefined
        ) {
          <ng-container formGroupName="carrierOfGeneticDiseases">
            <app-service-data-form-disease-history
              translationGroup="geneticCondition"
              [fieldSet]="fieldSet"
              [field]="ServiceDataFields.CarrierOfGeneticCondition"
            />
          </ng-container>
        }
      </ng-container>
    </ng-container>
    @if (
      carrierOfGeneticDiseases === null ||
      carrierOfGeneticDiseases === undefined
    ) {
      <ng-container formGroupName="shared">
        <ng-container formGroupName="patientHistory">
          @if (
            fieldSet.includes(ServiceDataFields.ChromosomalAbnormalityCarrier)
          ) {
            <ng-container formGroupName="chromosomalAbnormalityCarrier">
              <app-service-data-form-carrier-condition
                validationTranslation="serviceData.form.validation.chromosomalAbnormalityCarrier"
                [title]="
                  'serviceData.form.chromosomalAbnormalityCarrier' | translate
                "
                [property]="'isCarrier'"
                [fieldSet]="fieldSet"
                [field]="ServiceDataFields.ChromosomalAbnormalityCarrier"
              />
            </ng-container>
          }
        </ng-container>
      </ng-container>
      <ng-container formGroupName="mono">
        <ng-container formGroupName="patientHistory">
          @if (fieldSet.includes(ServiceDataFields.MonogenicDisorderCarrier)) {
            <ng-container formGroupName="monogenicDisorderCarrier">
              <app-service-data-form-carrier-condition
                validationTranslation="serviceData.form.validation.monogenicDisorderCarrier"
                [title]="
                  'serviceData.form.monogenicDisorderCarrier' | translate
                "
                [property]="'isCarrier'"
                [fieldSet]="fieldSet"
                [field]="ServiceDataFields.MonogenicDisorderCarrier"
              />
            </ng-container>
          }
        </ng-container>
      </ng-container>
    }
    <ng-container formGroupName="shared">
      <ng-container formGroupName="patientHistory">
        <app-service-data-form-cancer-history [fieldSet]="fieldSet" />

        <ng-container formGroupName="albuminTherapy">
          <app-service-data-form-condition-history
            [config]="{
              type: RadioFormType.Double,
              title: {
                question:
                  'serviceData.form.albuminTherapy.hasReceived' | translate,
                subQuestion:
                  'serviceData.form.albuminTherapy.isRelevant' | translate,
              },
              validationTranslation: {
                subAnswer: 'serviceData.form.validation.albuminTherapy',
              },
            }"
            [fieldSet]="fieldSet"
            [field]="ServiceDataFields.HumanSerumAlbuminTherapy"
          />
        </ng-container>

        <ng-container formGroupName="cellularImmunotherapy">
          <app-service-data-form-condition-history
            [config]="{
              type: RadioFormType.Double,
              title: {
                question:
                  'serviceData.form.cellularImmunotherapy.hasReceived'
                  | translate,
                subQuestion:
                  'serviceData.form.cellularImmunotherapy.isRelevant'
                  | translate,
              },
              validationTranslation: {
                subAnswer: 'serviceData.form.validation.cellularImmunotherapy',
              },
            }"
            [fieldSet]="fieldSet"
            [field]="ServiceDataFields.CellularImmunotherapy"
          />
        </ng-container>

        <ng-container formGroupName="stemCellTherapy">
          <app-service-data-form-condition-history
            [config]="{
              type: RadioFormType.Single,
              title: {
                question: 'serviceData.form.stemCellTherapy' | translate,
              },
              validationTranslation: {
                answer: 'serviceData.form.validation.stemCellTherapy',
              },
            }"
            [fieldSet]="fieldSet"
            [field]="ServiceDataFields.StemCellTherapy"
          />
        </ng-container>

        <ng-container formGroupName="transplantSurgery">
          <app-service-data-form-condition-history
            [config]="{
              type: RadioFormType.Single,
              title: {
                question: 'serviceData.form.transplantSurgery' | translate,
              },
              validationTranslation: {
                answer: 'serviceData.form.validation.transplantSurgery',
              },
            }"
            [fieldSet]="fieldSet"
            [field]="ServiceDataFields.TransplantSurgery"
          />
        </ng-container>

        <ng-container formGroupName="bloodTransfusion">
          <app-service-data-form-condition-history
            [config]="{
              type: RadioFormType.Double,
              title: {
                question:
                  'serviceData.form.bloodTransfusion.hasReceived' | translate,
                subQuestion:
                  'serviceData.form.bloodTransfusion.isRelevant' | translate,
              },
              validationTranslation: {
                subAnswer: 'serviceData.form.validation.bloodTransfusion',
              },
            }"
            [fieldSet]="fieldSet"
            [field]="ServiceDataFields.BloodTransfusion"
          />
        </ng-container>
      </ng-container>
    </ng-container>
    <ng-container formGroupName="nippt">
      <ng-container formGroupName="patientHistory">
        <ng-container formGroupName="anotherPregnancy">
          <app-service-data-form-recent-pregnancy [fieldSet]="fieldSet" />
        </ng-container>

        <app-service-data-form-condition-history
          [config]="{
            type: RadioFormType.Single,
            answerProperty: 'anyReceivedStemCell',
            title: {
              question:
                'serviceData.form.nippt.participantsStemCellTherapy'
                | translate,
            },
            validationTranslation: {
              answer: 'serviceData.form.validation.nippt',
            },
          }"
          [fieldSet]="fieldSet"
          [field]="ServiceDataFields.ParticipantsStemCellTherapy"
        />

        <app-service-data-form-condition-history
          [config]="{
            type: RadioFormType.Single,
            answerProperty: 'anyReceivedBloodTransfusion',
            title: {
              question:
                'serviceData.form.nippt.participantsBloodTransfusion'
                | translate,
            },
            validationTranslation: {
              answer: 'serviceData.form.validation.nippt',
            },
          }"
          [fieldSet]="fieldSet"
          [field]="ServiceDataFields.ParticipantsBloodTransfusion"
        />
      </ng-container>
    </ng-container>
    @if (showFraternityQuestions) {
      <ng-container formGroupName="paternity">
        <ng-container formGroupName="patientHistory">
          <div class="row">
            <div class="col-12 col-md-6 mb-3">
              <div class="row align-items-center">
                <div class="col-12 col-sm-6 col-md-4 mb-1">
                  <label for="fraternitySameBiologicalMother">{{
                    'serviceData.form.paternity.sameBiologicalMother'
                      | translate
                  }}</label>
                </div>
                <div class="col-12 col-sm-6 col-md-8">
                  <app-select
                    class="w-100"
                    id="fraternitySameBiologicalMother"
                    formControlName="isSameBiologicalMother"
                    [attr.data-cy]="
                      ServiceDataFields.FraternityInformation +
                      '-same-biological-mother-select'
                    "
                    [placeholder]="
                      'serviceData.form.paternity.sameBiologicalMotherPlaceholder'
                        | translate
                    "
                  >
                    @for (answer of sameBiologicalMotherAnswers; track answer) {
                      <app-select-option
                        [value]="answer"
                        [label]="
                          'serviceData.form.paternity.sameBiologicalMotherAnswers.' +
                            answer | translate
                        "
                      />
                    }
                  </app-select>
                </div>
              </div>
              <div class="row justify-content-end">
                <div class="col-12 col-sm-6 col-md-8">
                  <app-validation-error
                    for="isSameBiologicalMother"
                    translations="validation.generic"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12 col-md-6 mb-3">
              <div class="row align-items-center">
                <div class="col-12 col-sm-6 col-md-4 mb-1">
                  <label for="fraternitySharedParent">{{
                    'serviceData.form.paternity.sharedParent' | translate
                  }}</label>
                </div>
                <div class="col-12 col-sm-6 col-md-8">
                  <app-select
                    class="w-100"
                    id="fraternitySharedParent"
                    formControlName="wantToKnow"
                    [attr.data-cy]="
                      ServiceDataFields.FraternityInformation +
                      '-shared-parent-select'
                    "
                    [placeholder]="
                      'serviceData.form.paternity.sharedParentPlaceholder'
                        | translate
                    "
                  >
                    @for (parent of sharedParents; track parent) {
                      <app-select-option
                        [value]="parent"
                        [label]="
                          'serviceData.form.paternity.sharedParents.' + parent
                            | translate
                        "
                      />
                    }
                  </app-select>
                </div>
              </div>
              <div class="row justify-content-end">
                <div class="col-12 col-sm-6 col-md-8">
                  <app-validation-error
                    for="wantToKnow"
                    translations="validation.generic"
                  />
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </ng-container>
    }
  </section>
}
